export var HERRAMIENTA_LAPIZ = 'lapiz';
export var HERRAMIENTA_BORRADOR = 'borrador';
export var HERRAMIENTA_MARCADOR = 'marcador';
export var HERRAMIENTA_ELIMINAR_DIBUJO = 'eliminar';
export var COLOR_LAPIZ_DEFECTO = '#000000';
export var GROSOR_LAPIZ_DEFECTO = 2;
export var COLOR_MARCADOR_DEFECTO = '#00ff00';
export var GROSOR_MARCADOR_DEFECTO = 10;
export var ALPHA_MARCADOR_DEFECTO = 0.5;
export var GROSOR_BORRADOR_DEFECTO = 20;
export var RESOLUCION_DEFECTO = {
  w: 500,
  h: 500
};